import { render, staticRenderFns } from "./IPAddrList.vue?vue&type=template&id=7b0a56b6&"
import script from "./IPAddrList.vue?vue&type=script&lang=js&"
export * from "./IPAddrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports